import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Radio, Square, Users } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Panel, StatusPill } from "@/components/Peep";

function SessionRow({ s, onEnd }) {
  return (
    <div data-testid={`admin-live-row-${s.id}`} className="flex flex-wrap items-center justify-between gap-3 border-t border-white/5 py-3">
      <div>
        <p className="text-sm font-semibold">{s.title}</p>
        <p className="text-xs text-[#a7a0af]">{s.creator_name} · {s.access_level} · {s.scheduled_for ? new Date(s.scheduled_for).toLocaleString() : "unscheduled"}</p>
      </div>
      <div className="flex items-center gap-2">
        {s.status === "live" && <span data-testid={`admin-live-viewers-${s.id}`} className="flex items-center gap-1 text-xs text-[#c7c1cf]"><Users size={12} /> {s.viewers ?? "–"}</span>}
        <StatusPill status={s.status} />
        {s.status === "live" && (
          <button onClick={() => onEnd(s)} data-testid={`admin-live-end-${s.id}`} className="flex items-center gap-1 rounded-lg border border-red-400/30 px-2 py-1.5 text-xs text-red-300"><Square size={12} /> End broadcast</button>
        )}
      </div>
    </div>
  );
}

export default function AdminLiveMonitor() {
  const [d, setD] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/live").then((r) => setD(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);
  const end = async (s) => {
    if (!window.confirm(`End "${s.title}" by ${s.creator_name} for everyone now?`)) return;
    try {
      await api.post(`/admin/live/${s.id}/end`);
      toast.success("Broadcast ended");
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  return (
    <div data-testid="admin-live" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Live monitor</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Every creator broadcast across PEEPING. Refreshes every 15 seconds.</p>
      </div>
      <Panel title="Sessions" action={<span data-testid="admin-live-now" className="flex items-center gap-1 text-xs text-[#f0a8fa]"><Radio size={12} /> {d?.live_now ?? 0} live now</span>}>
        {!d && <p className="text-sm text-[#a7a0af]">Loading…</p>}
        {d && d.sessions.length === 0 && <p data-testid="admin-live-empty" className="text-sm text-[#a7a0af]">No live sessions scheduled yet.</p>}
        {d?.sessions.map((s) => <SessionRow key={s.id} s={s} onEnd={end} />)}
      </Panel>
    </div>
  );
}
